
import $ from 'jquery';
import axios from 'axios';
import {chinamobile} from '@/api/validate';
import { swiper, swiperSlide, directive } from 'vue-awesome-swiper';
import logimg from '../../../static/images/longlog.png';
import fertilityTwoBg  from './images/questionnaireConBg.png';
import onetopimg from './images/top.png';
import judementTempelet from '@/components/questionnaireTempelet/judementTempelet.vue';
import ChooseTempelet from '@/components/questionnaireTempelet/chooseTempelet.vue';
import Choices from '@/components/Subjects/Choices'
import Judgement from '@/components/Subjects/Judgement'
import ShortAnswer from '@/components/Subjects/ShortAnswer'
import MultipleChoices from '@/components/Subjects/MultipleChoices'
import Icon from 'vux/src/components/icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'

import XInput from 'vux/src/components/x-input/index'
import {fetch, promptMessage} from '@/api/dataHandling'
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil';


/**
*  字段说明：
*  examName 名称
*  examType 1在线考试，分值在每题上，是否正确  2 在线问卷 无分数、无测试结果 3 在线测试，分数在每个答案上，后台计算分值不一样
*  canAnwser 是否可以继续答题，后台控制
*  subjects 试题信息
*  personExams 答题信息
* personInfoId 个人基本信息id
*/
export default {
directives: {
TransferDom,
swiper: directive
},
components: {
judementTempelet,ChooseTempelet,swiper, swiperSlide,Icon, XInput, Choices, Group, Cell, XHeader, Grid, GridItem, Divider, Card, XButton, XDialog, Judgement, Loading, MultipleChoices, FormPreview, ShortAnswer
},
data () {
return {
chinamobile,
logimg,
fertilityTwoBg,
onetopimg:onetopimg,
loadingShow: false,
show: false,
modules: {},
tel:'',
name:'',
currentModule: {
subjects:[]
},
currentModuleIndex: 0,
queryParam: {
examinationId: undefined
},
setArry:[],
examName: undefined,
attention: '',
personInfoId: '',
personExams: {},
canAnwser: '',
examType: '',
personInfo: {},
score: 0,
evalLevel: '',
eval: '',
suggest: '',
remark: '',
personModule: [],
swperIndex:0,
canSubmit: false,
swiperOption: {

notNextTick: true,//notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
direction: 'vertical',//水平方向移动
grabCursor: true,//鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
setWrapperSize: true,//Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
autoHeight: true,//自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
slidesPerView: 1,//设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
mousewheel: false,//开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
mousewheelControl: false,//同上
height: window.innerHeight, // 高度设置，占满设备高度
resistanceRatio: 0,//抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
observeParents: true,//将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
observer:true,
updateOnWindowResize:true,
observeSlideChildren:true,
debugger: true,
resize: function(){
this.update(); 
},

onTransitionStart(swiper) {
},

}
}
},
created () {
this.loadingShow = true
/*
this.startExam()*/
},
mounted () {

let _this = this;
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
});
$('body').css({backgroundColor:'#fff'});
this.getWechatCode() 
},
computed: {
swiper() {
return this.$refs.mySwiper.swiper
}
},
methods: {
nextPage(){
this.swiper.slideTo(1, 1000, false);
},
ChooseChange(obj){

this.currentModule.subjects[obj.index] = obj.cloums;
console.log(1,obj,this.currentModule.subjects)
if(obj.value.length !=0){
if(obj.cloums.type == 1 || obj.cloums.type == 3){  //单选  或者判断
for (let j = 0; j < this.currentModule.subjects.length; j++) {
if(!this.currentModule.subjects[j].answer){
this.swiper.slideTo(j+2, 1000, false);
return false;
}
}

}
}


},
startExam: function () {
getken()
/*   this.openid = 'o8hchv8N9N0gNaprrJXGRjiJ1VoE'*/
if (!this.openid) { // 未获取到个人基本信息，不加载页面
return
}
this.queryParam.examinationId = getUrlParam('id')
fetch('post', urlConfig.examSubjectGet, {
examinationId: this.queryParam.examinationId,
personInfoId: this.openid
}).then(resp => {
const {examName, modules, personExams, canAnwser, examType, attention, remark} = resp
this.examName = examName
this.canAnwser = canAnwser
this.examType = examType
this.attention = attention
this.modules = modules
/*          console.log(this.modules,565555)*/
this.remark = remark
if (this.modules) {
this.currentModule = modules[0]
for (let i = 0; i < this.currentModule.subjects.length; i++) {
if (this.currentModule.subjects[i].choices) {
for (let j = 0; j < this.currentModule.subjects[i].choices.options.length; j++) {
this.currentModule.subjects[i].choices.options[j]['inputIndex'] = 2
this.currentModule.subjects[i].choices.options[j]['inputVal'] = ''
}
}
}
}
if (this.examType === '3' && this.canAnwser === 1) {
this.getPersonInfo(this.openid)
}
this.setPersonExams(personExams)
this.loadingShow = false
}).catch((e) => {
console.log(e)
this.loadingShow = true
})
},
setPersonExams (personExams) {

if (personExams.length > 0) {

this.personExams = personExams
const {score, evalLevel, suggest, modules} = personExams[0]
this.score = score
this.evalLevel = evalLevel
this.eval = personExams[0].eval;
this.suggest = suggest
this.personModule = modules
}
if(this.canAnwser == 1){
$('body').css({height:'100vh',overflow: 'hidden'});
}else{
$('body').css({height:'auto',overflowY: 'scroll'});
}
},
submit(){
let moduleJson = []

let moduleTemp = {}
moduleTemp.examinationModuleId = this.currentModule.id
for (let j = 0; j < this.currentModule.subjects.length; j++) {
let temp = {}
temp.subjectId = this.currentModule.subjects[j].subjectId
console.log(this.currentModule.subjects[j],55)
if(!this.currentModule.subjects[j].answer){
this.$vux.toast.show({
type:'text',
text: '第'+(j+1)+'题未填写！'
});
this.swiper.slideTo(j+2, 1000, false);
return false;
}
if(this.name.trim() != '' && this.tel.trim() !=''){
if(!chinamobile(this.tel).valid){
this.$vux.toast.show({
type:'text',
text: '手机号码格式不对'
});
return false;
}

}else{
this.$vux.toast.show({
type:'text',
text: '请输入姓名和电话'

});
return false;
}

temp.anwser = this.currentModule.subjects[j].answer
temp.userInput = JSON.stringify(this.currentModule.subjects[j].userInput)
if (!moduleTemp.anwsers) {
moduleTemp.anwsers = []
}
moduleTemp.anwsers.push(temp)
}
moduleJson.push(moduleTemp)

console.log('提交',this.currentModule,this.modules)
if (moduleJson) {
this.loadingShow = true;
let paramId = window.localStorage.getItem('paramId')
fetch('post', urlConfig.examSubjectSave, {personType:this.$route.query.personType,userName:this.name,mobile:this.tel,examType:this.examType, examinationId: this.queryParam.examinationId, personInfoId: this.openid,modules:moduleJson})
.then(resp => {
this.show = true;
this.canAnwser = 2;
this.loadingShow = false;
this.setPersonExams(resp.personExams)
}).catch(() => {})
}
},
getPersonInfo (openid) {
fetch('get', urlConfig.queryPersonInfo + '?personInfoId=' + openid).then(response => {
this.personInfo = response

}).catch(() => {})
},
getPersonInfoId (openId) {
let hosCode = window.localStorage.getItem('hosCode')
axios.post(urlConfig.getWxBasicInfoByOpenId + '?openid=' + openId + '&hosCode=' + hosCode).then(res => {

let resultCode = res.data.resultCode


if (resultCode === 'error') {
this.toReg(hosCode)
} else {
axios.get(urlConfig.GetSfzh + '?openid=' + openId).then(response => {

const {resultCode} = response.data
if (resultCode === 'success') {
const {sfzh} = response.data.data

if (sfzh) {
fetch('post', urlConfig.GetPersonInfoId + '?sfzh=' + sfzh).then(response => {
this.personInfoId = response.personInfoId
this.startExam() 
}).catch(() => {
})
}
} else {


promptMessage('请先在公众号我的服务注册个人信息!')





}
}).catch(() => {
})
}
}).catch(error => {
console.log(error)
})
},
getOptions (options, anwser) {
let op
for (let k = 0; k < options.length; k++) {
if (anwser === options[k].id) {
op = options[k]
break
}
}
return op
},
toReg (hosCode) {
window.location.replace('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MDM0MzI2Mw==&scene=124#wechat_redirect');
},
getOpenId (code) {
getken()
let hosCode = window.localStorage.getItem('hosCode')
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' + code + '&hosCode=' + hosCode).then(response => {
const {data} = response
const {resultMsg, openid} = data
if (openid) {
window.localStorage.setItem('openid', openid)
this.openid = openid;
this.getPersonInfoId(openid)
} else {
/* promptMessage(resultMsg) */
let parmasquery = '?bb=1'
for (let i in this.$route.query) {
if (i != 'code' && i != 'bb') {
parmasquery = parmasquery + '&' + i + '=' + this.$route.query[i]
}
}
window.location.replace('http://front.wh.jinxin-fertility.com/questionnaire' + parmasquery + '&time=' + ((new Date()).getTime()));
}
})
},
getWechatCode () {
this.loadingShow = true
let _this = this

let hosCode = _this.$route.query.hosCode
let paramId = _this.$route.query.paramId
if (!hosCode) {
hosCode = '420100000002'
}
window.localStorage.setItem('hosCode', hosCode)
window.localStorage.setItem('paramId', paramId)
getken()
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href) + '&hosCode=' + hosCode).then(response => {
const {data} = response
const code = getUrlParam('code')
if (!_this.$route.query.code) {
if (code == null || code === '') {
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + data.appId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
}
} else {
_this.getOpenId(code)
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/project/exam/questionnaire.vue